var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('app-top-bar'),_c('v-container',{style:('max-width: ' + _vm.containerWidth),attrs:{"fluid":"","grid-list-lg":""}},[_c('menu-top'),_c('div',{staticClass:"text-center pa-3"},[_c('h2',[_vm._v("Штрафы")])]),_c('fines-table')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }